import React, { useState } from 'react';
import { t } from '@configuratorware/configurator-frontendgui/Framework/i18n';
import { Button, DialogActions, DialogContent, Divider, makeStyles, Typography } from '@material-ui/core';
import CustomDialog from '@configuratorware/configurator-frontendgui/Shared/Components/CustomDialog';
import MarkdownText from '../MarkdownText/MarkdownText';
import { green, lightergreyAlternative } from '../../Constants/Colors';
import { hidePrices } from '../../Helpers';
import PriceInfoDialog from '../PriceInfoDialog/PriceInfoDialog';

const useStyles = makeStyles(
  () => ({
    dialog: {
      '& .MuiDialog-paper': {
        borderRadius: 0,
        borderTop: 'none',
      },
      '& h2.MuiTypography-root.MuiTypography-h6': {
        fontWeight: 400,
      },
    },
    dialogActions: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      '&.MuiDialogActions-root': {
        padding: '16px !important',
      },
    },
    basePriceContainer: {
      display: 'flex',
      flexDirection: 'column',
      backgroundColor: lightergreyAlternative,
      width: 'max-content',
      padding: 16,
      marginTop: 32,
      marginBottom: 32,
    },
    individualNursingBedLabel: {
      fontFamily: 'Inter',
      fontSize: '15px',
      lineHeight: '24px',
    },
    individualNursingBedPrice: {
      fontSize: '24px !important',
      color: green,
      fontWeight: 600,
      cursor: 'pointer',
    },
    btn: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    buttonLabel: {
      fontFamily: 'Inter',
      fontWeight: 700,
      textTransform: 'uppercase',
      color: green,
    },
  }),
  {
    name: 'AdditionalInfoDialog',
  }
);
interface AdditionalInfoDialogProps {
  title: string;
  isOpen: boolean;
  itemDescription?: string;
  itemPrice?: number;
  onCancel?: () => void;
  onButtonClick?: () => void;
}

const AdditionalInfoDialog = ({
  title,
  isOpen,
  itemDescription,
  itemPrice,
  onCancel,
  onButtonClick,
}: AdditionalInfoDialogProps) => {
  const classes = useStyles();
  const pricesHidden = hidePrices();
  const [showPriceInfo, setShowPriceInfo] = useState(false);
  const onPriceClick = () => {
    setShowPriceInfo(true);
  };

  const onCancelPriceInfo = () => {
    setShowPriceInfo(false);
  };
  return (
    <CustomDialog
      dialogTitle={title}
      open={isOpen}
      onCancel={onCancel && onCancel}
      className={classes.dialog}
    >
      <DialogContent>
        <MarkdownText text={itemDescription} />
        <div className={classes.basePriceContainer}>
          <Typography variant="body1" className={classes.individualNursingBedLabel}>
            {t('additionalInfo.yourIndividualNursingBed')}
          </Typography>
          {!pricesHidden && itemPrice && (
            <Typography onClick={onPriceClick} variant="body1" className={classes.individualNursingBedPrice}>
              {t('additionalInfo.from')} {itemPrice} €*
            </Typography>
          )}
          <PriceInfoDialog onCancel={onCancelPriceInfo} open={showPriceInfo} />
        </div>
      </DialogContent>
      <Divider />
      <DialogActions className={classes.dialogActions}>
        <Button className={classes.btn} onClick={onButtonClick}>
          <Typography variant="body1" className={classes.buttonLabel}>
            {t('additionalInfo.continueConfiguration')}
          </Typography>
        </Button>
      </DialogActions>
    </CustomDialog>
  );
};

export default AdditionalInfoDialog;
